<script lang="ts">
  import { onMount } from "svelte";
  import ChatPopup from "../components/content/chat/ChatPopup.svelte";
  import type { Document } from "../services/api/types.js";
  import { logError, logInfo, logWarning } from "../services/logging/log-handler.js";

  let chatId = "";
  let documents: Document[] = [];

  onMount(() => {
    // Get parameters from URL
    const urlParams = new URLSearchParams(window.location.search);
    chatId = urlParams.get("chatId") || "default-chat";

    // Parse documents from URL parameters
    const documentsParam = urlParams.get("documents");
    if (documentsParam) {
      try {
        documents = JSON.parse(documentsParam);
      } catch (error) {
        logError(error, "ChatbotPage", undefined, { message: "Error parsing documents from URL" });
        documents = [];
      }
    }
  });
</script>

<ChatPopup />
